export const IMAGES = {
  logo: require('./images/thumbs/logo.png'),
  defaultImage: require('./images/thumbs/default-image.jpg'),
  backgroundLogin: require('./images/bg_auth.svg'),
  user64: require('./images/user_64.png'),
  user512: require('./images/user_512.png'),
  noImage: require('./images/no-image.png'),
  icon_love: require('./images/icon_love.png'),
  icon_like: require('./images/icon_like.png'),
  icon_lol: require('./images/icon_lol.png'),
  icon_sad: require('./images/icon_sad.png'),
  icon_angry: require('./images/icon_angry.png'),
  icon_thumb_down: require('./images/icon_thumsp_down.png'),
  logo_defaultProfileImage: require('./images/logo_defaultProfileImage.png'),
}

export const ICONS = {
  selectDownIcon: require('./icons/select-down.png'),
  boldIcon: require('./icons/b-icon.png'),
  italicIcon: require('./icons/italic-icon.png'),
  h1Icon: require('./icons/h1-icon.png'),
  h2Icon: require('./icons/h2-icon.png'),
  linkIcon: require('./icons/link-icon.png'),
  blockquoteIcon: require('./icons/quote.png'),
  imageIcon: require('./icons/image-icon.png'),
  listBulletIcon: require('./icons/list-bullet-icon.png'),
  listNumberIcon: require('./icons/list-numbers-icon.png'),
  whiteBoldIcon: require('./icons/white-b.png'),
  whiteItalicIcon: require('./icons/white-italic.png'),
  whiteH1Icon: require('./icons/white-h1.png'),
  whiteH2Icon: require('./icons/white-h2.png'),
  whiteLinkIcon: require('./icons/white-link.png'),
  whiteBlockquoteIcon: require('./icons/white-quote.png'),
  whiteImageIcon: require('./icons/white-image.png'),
  whiteListBulletIcon: require('./icons/white-list-bullet.png'),
  whiteListNumberIcon: require('./icons/white-list-numbers.png'),
}
export * from './react-icon'
